import {langCodes, urlPrefix} from './localePrefix'
import shouldNoindex from './noindex'

// <link rel="alternate" hreflang> definitions for a route. `translator` is the vue-i18n
// instance (passed in so this stays a pure function of its inputs).
export default function buildAlternateTags(to, origin, translator)
{
  const meta = to.meta || {}
  const tags = []

  // hreflang tells a crawler which localized variant to index, which contradicts a page asking
  // not to be indexed - so emit no alternates here. The router still sends the noindex meta.
  if (shouldNoindex(to.path, meta))
  {
    return tags
  }

  if (meta.key)
  {
    const hrefForLocale = lc =>
    {
      const key = 'router.links.' + meta.key
      // A missing translation would leak the literal key path into a live hreflang URL.
      if (!translator.te(key, lc))
      {
        console.error('Missing slug for hreflang:', key, lc)
        return null
      }
      const slug = String(translator.t(key, lc)).replace(/^\//, '')
      return origin + urlPrefix(lc) + '/' + slug
    }
    Object.keys(langCodes).forEach(lc =>
    {
      const href = hrefForLocale(lc)
      if (href)
      {
        tags.push({rel: 'alternate', hreflang: langCodes[lc], href: href})
      }
    })
    const defaultHref = hrefForLocale('gb')
    if (defaultHref)
    {
      tags.push({rel: 'alternate', hreflang: 'x-default', href: defaultHref})
    }
  }
  else if (to.name === 'Home')
  {
    Object.keys(langCodes).forEach(lc =>
    {
      tags.push({rel: 'alternate', hreflang: langCodes[lc], href: origin + urlPrefix(lc) + '/'})
    })
    tags.push({rel: 'alternate', hreflang: 'x-default', href: origin + '/'})
  }

  return tags
}
